import { render, staticRenderFns } from "./CustomLottiePlayer.vue?vue&type=template&id=594fb10f&"
import script from "./CustomLottiePlayer.vue?vue&type=script&lang=js&"
export * from "./CustomLottiePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports